angular.module('gym.components').directive('contactColoredBar', ["$stateParams", function($stateParams) {
  return {
    restrict: 'EA',
    link: function($scope, element) {
      // add members-page or prospects-page class
      return element.addClass(`${$stateParams.contactType}-page`);
    }
  };
}]);
